export default class PhaseModel {
    constructor(id, name, shortName, projectId) {
        this.id = id;
        this.name = name;
        this.shortName = shortName;
        this.projectId = projectId;
    }
}



// WEBPACK FOOTER //
// ./src/models/phase.js